import { useTranslation } from 'react-i18next';
import { 
  Home, Building, Bath, Wind, CarFront, 
  Warehouse, FileCheck, Utensils, Users, Sofa, PaintBucket, Car, 
  Trees, Flower, TreeDeciduous, Building2, Construction, Landmark, 
  ParkingCircle, Bed, ArrowUpDown, Dog, Key, UserPlus, Umbrella, 
  ParkingSquare, Shirt, Soup, Droplets, Grid3X3, Flame, 
  DoorOpen, UsersRound, Warehouse as LoftIcon, FileSpreadsheet
} from 'lucide-react';

export const useFlatFeature = () => {
  const { t } = useTranslation();

  return (key: string) => {
    const featureMap: { [key: string]: { name: string; icon: React.ElementType } } = {
      attic: { name: t('components.flatFeatures.attic'), icon: Home },
      available_for_rent: { name: t('components.flatFeatures.available_for_rent'), icon: Key },
      balcony: { name: t('components.flatFeatures.balcony'), icon: Wind },
      barrier_free: { name: t('components.flatFeatures.barrier_free'), icon: UserPlus },
      basement: { name: t('components.flatFeatures.basement'), icon: Building },
      bathtub: { name: t('components.flatFeatures.bathtub'), icon: Bath },
      bathroom_window: { name: t('components.flatFeatures.bathroom_window'), icon: Wind },
      carport: { name: t('components.flatFeatures.carport'), icon: CarFront },
      cellar: { name: t('components.flatFeatures.cellar'), icon: Warehouse },
      certificate_of_eligibility: { name: t('components.flatFeatures.certificate_of_eligibility'), icon: FileCheck },
      first_time_use: { name: t('components.flatFeatures.first_time_use'), icon: DoorOpen },
      kitchen: { name: t('components.flatFeatures.kitchen'), icon: Utensils },
      flat_share_possible: { name: t('components.flatFeatures.flat_share_possible'), icon: Users },
      furnished: { name: t('components.flatFeatures.furnished'), icon: Sofa },
      fully_renovated: { name: t('components.flatFeatures.fully_renovated'), icon: PaintBucket },
      garage: { name: t('components.flatFeatures.garage'), icon: Car },
      garden: { name: t('components.flatFeatures.garden'), icon: Trees },
      garden_part: { name: t('components.flatFeatures.garden_part'), icon: Flower },
      garden_shared: { name: t('components.flatFeatures.garden_shared'), icon: TreeDeciduous },
      ground_floor: { name: t('components.flatFeatures.ground_floor'), icon: Building2 },
      new_building: { name: t('components.flatFeatures.new_building'), icon: Construction },
      new_building_project: { name: t('components.flatFeatures.new_building_project'), icon: Construction },
      old_building: { name: t('components.flatFeatures.old_building'), icon: Landmark },
      parking: { name: t('components.flatFeatures.parking'), icon: ParkingCircle },
      partly_furnished: { name: t('components.flatFeatures.partly_furnished'), icon: Bed },
      elevator: { name: t('components.flatFeatures.elevator'), icon: ArrowUpDown },
      pets_allowed: { name: t('components.flatFeatures.pets_allowed'), icon: Dog },
      rented: { name: t('components.flatFeatures.rented'), icon: Key },
      senior_friendly: { name: t('components.flatFeatures.senior_friendly'), icon: UserPlus },
      terrace: { name: t('components.flatFeatures.terrace'), icon: Umbrella },
      underground_parking: { name: t('components.flatFeatures.underground_parking'), icon: ParkingSquare },
      washing_machine: { name: t('components.flatFeatures.washing_machine'), icon: Shirt },
      dishwasher: { name: t('components.flatFeatures.dishwasher'), icon: Soup },
      guest_toilet: { name: t('components.flatFeatures.guest_toilet'), icon: Droplets },
      parquet: { name: t('components.flatFeatures.parquet'), icon: Grid3X3 },
      floor_heating: { name: t('components.flatFeatures.floor_heating'), icon: Flame },
      first_occupancy: { name: t('components.flatFeatures.first_occupancy'), icon: DoorOpen },
      suitable_for_shared_living: { name: t('components.flatFeatures.suitable_for_shared_living'), icon: UsersRound },
      loft: { name: t('components.flatFeatures.loft'), icon: LoftIcon },
      housing_benefit_required: { name: t('components.flatFeatures.housing_benefit_required'), icon: FileSpreadsheet },
    };

    return featureMap[key] || { name: key, icon: Home };
  };
};
